export default __webpack_public_path__ + "static/media/intro1.81dfcef3.png";